import i18n from 'i18next';
import {
  DEFAULT_TEMPLATE_VISIBILITY_VALUE,
  LABEL_KEYS,
  TRANSLATION_KEY_PREFIX,
} from './constants.ts';

export const removeSelectedArchitectures = (
  allArchitectures: Architecture[],
  selectedArchitectures: Architecture[],
): Architecture[] => {
  return allArchitectures.filter((arch) => {
    return selectedArchitectures.every((selected) => selected.uid !== arch.uid);
  });
};

export const buildVisibilityCellValue = (
  visibilityValueFromApi = DEFAULT_TEMPLATE_VISIBILITY_VALUE,
): FormattedTemplateVisibilityValues => {
  return i18n.t(
    `${TRANSLATION_KEY_PREFIX}${LABEL_KEYS[visibilityValueFromApi]}`,
  );
};
